import { Box, Typography, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

import { Checkbox } from '@verantos-dev/shared-components';

export type CohortBuilderEditModalFilterSectionProps = {
  id: string;
  title: string;
  showCheckbox?: boolean;
  checkboxDisplayLabel?: string;
  checked?: boolean;
  onChangeCheckbox?: (id: string, checked: boolean) => void;
  viewMode?: boolean;
};

export const CohortBuilderEditModalFilterSection = ({
  children,
  id,
  title,
  showCheckbox = false,
  checkboxDisplayLabel,
  checked,
  onChangeCheckbox,
  viewMode = false,
}: PropsWithChildren<CohortBuilderEditModalFilterSectionProps>) => {
  const theme = useTheme();

  return (
    <Box
      data-testid={`cohortBuilderEditModalFilterSection-${id}`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        mb: theme.spacing(4),
      }}
    >
      <Box data-testid={`cohortBuilderEditModalFilterSection-title-${id}`}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 700, mb: theme.spacing(4), color: theme.palette.text.primary }}
        >
          {title}
        </Typography>
        {showCheckbox && (
          <Box sx={{ pb: theme.spacing(4) }}>
            <Checkbox
              id="cohortBuilderEditModalFilterSection-title-checkbox"
              displayLabel={checkboxDisplayLabel || ''}
              showBorderBox={false}
              width={260}
              checked={checked}
              noHover={true}
              displayLabelSize={'medium'}
              onChange={(_id, _checked) => onChangeCheckbox && onChangeCheckbox(_id, _checked)}
              disabled={viewMode}
            />
          </Box>
        )}
      </Box>
      <Box
        data-testid={`cohortBuilderEditModalFilterSection-children-${id}`}
        sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(4), width: '100%' }}
      >
        {children}
      </Box>
    </Box>
  );
};
